import { getApiErrorCode, getApiErrorDetails } from "@gettactic/helpers";

/** The editor can't be used any more: the person no longer manages a zone
 *  on this floor. */
export const isNoLongerZoneManager = (error: unknown): boolean =>
  getApiErrorCode(error) === "cannot_manage_resource";

const countOf = (ids: unknown): number => (Array.isArray(ids) ? ids.length : 0);

/** A readable reason a zone manager's map save was refused. */
export const describeZoneManagerMapError = (error: unknown): string => {
  const code = getApiErrorCode(error);
  if (code === "cannot_manage_resource") {
    return "You no longer manage a zone here.";
  }
  if (code !== "map_out_of_scope") {
    return "The map could not be saved.";
  }

  const details = getApiErrorDetails(error);
  switch (details?.reason) {
    case "shapes_changed":
      return "Only desks can be changed. Walls, furniture and regions must stay as they are, and existing desks can't move to another region.";
    case "spot_changed":
    case "spot_removed": {
      const count = countOf(details.resource_ids);
      if (count === 1) return "1 desk is outside your zones.";
      if (count > 1) return `${count} desks are outside your zones.`;
      return "Some desks are outside your zones.";
    }
    case "spot_outside_managed_region":
      return "New desks must be placed inside a region of your zones.";
    default:
      return "This floor can't be edited right now.";
  }
};
